






































import Vue, { PropType } from 'vue';

import Input from '../common/Input/Input.vue';
import RadioButton from '../common/CheckBox/CheckBox.vue';
import { DatasetAnalysisRule } from '@/interfaces/types/Dataset';

export default Vue.extend({
  components: {
    Input,
    RadioButton,
  },
  props: {
    isOptionInvalid: {
      type: Boolean,
    },
    analysisRule: {
      type: Object as PropType<DatasetAnalysisRule>,
    },
  },
  data(): {
    fileTypeBools: boolean[];
    targetProp: string;
    csvNoHeader: boolean;
  } {
    return {
      fileTypeBools: [false, false],
      targetProp: '',
      csvNoHeader: false,
    };
  },
  mounted() {
    this.$emit('update:isOptionInvalid', this.computedInvalid);
  },
  computed: {
    computedInvalid(): boolean {
      return (
        /** 선택된 형식 1개로 제한 */
        this.fileTypeBools.filter((b) => b).length !== 1 ||
        /** CSV 선택 시 인덱스 0 이상 정수 체크 */
        (this.fileTypeBools[0] &&
          (isNaN(+this.targetProp) || +this.targetProp < 0)) ||
        /** targetProp 미입력 */
        this.targetProp === ''
      );
    },
    targetExt(): string {
      return this.fileTypeBools[0]
        ? 'csv'
        : this.fileTypeBools[1]
        ? 'json'
        : '';
    },
    localAnalysisRule(): DatasetAnalysisRule {
      return {
        targetExt: this.targetExt,
        targetProp: this.targetProp,
        csvNoHeader: this.csvNoHeader,
      };
    },
  },
  watch: {
    computedInvalid(invalid: boolean) {
      this.$emit('update:isOptionInvalid', invalid);
    },
    localAnalysisRule: {
      handler() {
        this.$emit('update:analysisRule', this.localAnalysisRule);
      },
      deep: true,
    },
  },
  methods: {
    keepItRadio(clickedIdx: number) {
      if (this.fileTypeBools[clickedIdx])
        this.fileTypeBools.forEach((_, idx) => {
          if (idx === clickedIdx) {
            return;
          } else {
            this.fileTypeBools[idx] = false;
          }
        });
    },
  },
});
